// ----------------------------------------------------------------------
// <copyright file="Izenda.SimpleGauge.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  const { get, last, getOr, truncate, times, inRange, constant, toString } = require('lodash/fp');
  module.exports = function(H) {
    var MIN_SIZE = 15;
    var MAX_CHARS = 10;
    var DEFAULT_MAX_CHARS = 10;
    var DEFAULT_BASED_FONT_SIZE = 14;

    var TEXT_COLOR = 'black';

    // This distance between name and value-unit in KPI container
    // var KPI_CENTRAL_DISTANCE = 10;

    var BASE_CHART_OPTS = 'pie';
    var IZENDA_CHART = 'izendaSimpleGauge';

    var defaultPlotOptions = H.getOptions().plotOptions,
      // baseChart = H.Series,
      baseChart = H.seriesTypes[BASE_CHART_OPTS],
      each = H.each;

    defaultPlotOptions[IZENDA_CHART] = H.merge(defaultPlotOptions[BASE_CHART_OPTS], {});

    H.seriesTypes[IZENDA_CHART] = H.extendClass(baseChart, {
      type: IZENDA_CHART,

      padding: 10,

      drawGraph: null,
      getSymbol: function() {},
      searchPoint: function() {},

      redraw: function() {
        this.render();
      },

      translate: function() {
        this.generatePoints();
      },

      generatePoints: function() {
        var series = this;
        var options = series.chart.options;
        var points = (series.points = []);

        options.series.map(function(serie) {
          points.push(new series.pointClass(series, serie.data));
        });
      },

      drawPoint: function(container, pointData) {
        var series = this;
        var chart = series.chart;
        var options = chart.options;
        var plotBox = chart.plotBox;
        var textColor = pointData.textColor || TEXT_COLOR;

        var serieNameContainer = chart.renderer.g('serie-name').add(container);
        var primaryContainer = chart.renderer.g('primary-kpi').add(container);
        var supKpiContainer = chart.renderer.g('sup-kpi').add(container);

        this.drawPointName(serieNameContainer, pointData, textColor);
        this.drawPrimaryKPI(primaryContainer, pointData, textColor);
        this.drawSupKPI(supKpiContainer, pointData, textColor);

        var primaryPosY = this.adjustPosition(
          (plotBox.width - primaryContainer.getBBox().width) / 2 - this.padding,
          (chart.containerHeight - primaryContainer.getBBox().height) / 2 - primaryContainer.getBBox().y,
          primaryContainer
        );
        this.adjustPosition(
          primaryPosY.x,
          primaryPosY.y - serieNameContainer.getBBox().height + serieNameContainer.getBBox().y,
          serieNameContainer
        );

        var supKPIPosX =
          get('supplementaryKPI.name', pointData) === ''
            ? primaryPosY.x + primaryContainer.getBBox().width / 2
            : primaryPosY.x;

        this.adjustPosition(supKPIPosX, primaryPosY.y - supKpiContainer.getBBox().y, supKpiContainer);

        // attack click event
        var onClick = get('chart.events.click', options);

        if (onClick) {
          container.element &&
            $izenda(container.element)
              .css({ cursor: 'pointer' })
              .on('click', onClick);
        }
      },

      adjustPosition: function(startPosX, startPosY, element) {
        element.attr({
          transform: ['translate(', Math.max(startPosX, 0), ',', Math.max(startPosY, 0), ')'].join('')
        });

        return { x: startPosX, y: startPosY };
      },

      addText: function(style, fontSize, content, container, maxChars) {
        maxChars = maxChars || this.maxChars;
        var adjustedText = this.adjustText(content, maxChars);
        var renderer = this.chart.renderer;

        return renderer
          .text(adjustedText)
          .css(
            $izenda.extend(style, {
              fontSize: fontSize + 'px'
            })
          )
          .add(container)
          .attr({
            title: content
          });
      },

      drawPointName: function(container, pointData, textColor) {
        var titleSize = this.getTitleSize();
        var chart = this.chart;
        var options = chart.options;

        if (!get('izendaOptions.showLabels', options)) {
          // do not draw point name
          return;
        }

        this.addText(
          {
            color: textColor
          },
          titleSize.fontSize,
          pointData.serieName,
          container,
          this.maxChars * 3
        );
      },

      containerWidth: function(container) {
        return container.getBBox().width;
      },

      drawPrimaryKPI: function(container, pointData, textColor) {
        var primarySize = this.getPrimarySize();
        var style = H.extend(
          {
            color: textColor,
            fontSize: primarySize.unitFontSize + 'px'
          },
          pointData.style
        );

        var primary = this.addText(
          $izenda.extend({}, style, this.getColorByThreshold(pointData.y, textColor)),
          primarySize.fontSize,
          this.getFormattedData(pointData.y, pointData),
          container
        );

        var primaryUnit = this.addText(style, primarySize.unitFontSize, ' ' + pointData.unit, container);

        // move unit after value
        primaryUnit.attr({
          transform: ['translate(', primary.getBBox().width, ',', 0, ')'].join('')
        });
      },

      getColorByThreshold: function(value, defaultColor) {
        var series = this;
        var chart = series.chart;
        var options = chart.options || {};
        var izendaOptions = options.izendaOptions || {};
        var threshold = izendaOptions.threshold || [];
        var index = 0;

        while (index < threshold.length) {
          if (inRange(threshold[index].from, threshold[index].to, value)) {
            break;
          }
          index++;
        }

        if (value === get('to', last(threshold))) {
          index = threshold.length - 1;
        }

        return {
          color: getOr(defaultColor, 'color', threshold[index] || {})
        };
      },

      drawSupKPI: function(container, pointData, textColor) {
        var supSize = this.getSupSize();
        var supplementaryKPIData = pointData.supplementaryKPI || {};

        var style = $izenda.extend(
          {
            color: textColor
          },
          supplementaryKPIData.style,
          {
            fontSize: supSize.fontSize + 'px'
          }
        );

        var supKpi = this.addText(style, supSize.fontSize, supplementaryKPIData.name, container, this.maxChars * 3 / 2);

        var supKpiUnit = this.addText(
          style,
          supSize.fontSize,
          [this.getFormattedData(supplementaryKPIData.value, supplementaryKPIData), supplementaryKPIData.unit].join(
            ' '
          ),
          container,
          this.maxChars * 3 / 2
        );

        supKpiUnit.attr({
          transform: ['translate(', supKpi.getBBox().width + this.padding, ',', 0, ')'].join('')
        });
      },

      getFormattedData: function(value, valueInfo) {
        return toString(valueInfo.dataFormatter ? valueInfo.dataFormatter(value, valueInfo.record) : value);
      },

      adjustText: function(text, maxChars) {
        if (!text) {
          return '';
        }

        text = text.toString().trim();
        return truncate({ length: maxChars }, text);
      },

      findFontSize: function(maxChars) {
        var chart = this.chart;
        var basedFontSize = 0;

        var tempString = times(constant('x'), maxChars).join('');

        do {
          basedFontSize++;
          var stringGraphic = chart.renderer
            .text(tempString)
            .css({
              fontSize: basedFontSize + 'px'
            })
            .add();
          var stringGraphicBBox = stringGraphic.getBBox();
          stringGraphic.destroy();
        } while (
          stringGraphicBBox.width < chart.chartWidth - 2 * this.padding &&
          stringGraphicBBox.height < chart.chartHeight - this.padding
        );
        return basedFontSize;
      },

      getTitleSize: function() {
        return {
          fontSize: this.basedFontSize / 3,
          maxChars: this.maxChars
        };
      },

      getPrimarySize: function() {
        return {
          fontSize: this.basedFontSize,
          maxChars: this.maxChars,
          unitFontSize: this.basedFontSize / 3
        };
      },

      getSupSize: function() {
        return {
          fontSize: this.basedFontSize / 3,
          maxChars: 3
        };
      },

      render: function() {
        var series = this;
        var chart = series.chart;
        var data = get('series[0].data[0]', chart.options);
        var graphic;

        var basedInfo = caculateBasedSize.call(this, chart);

        this.basedFontSize = basedInfo.basedFontSize;
        this.maxChars = basedInfo.maxChars;

        // draw point
        each(
          series.points,
          function(point) {
            graphic = point.graphic;

            if (graphic) {
              return;
            }

            point.graphic = chart.renderer.g('simple-gauge').add(chart.seriesGroup);
            this.drawPoint(point.graphic, data);
          }.bind(this)
        );

        function caculateBasedSize(chart) {
          var plotWidth = chart.plotSizeX;
          var plotHeight = chart.plotSizeY;
          var basedFontSize, maxChars;

          if (plotWidth < MIN_SIZE || plotHeight < MIN_SIZE) {
            return {
              basedFontSize: DEFAULT_BASED_FONT_SIZE,
              maxChars: DEFAULT_MAX_CHARS
            };
          }

          maxChars = MAX_CHARS;
          basedFontSize = this.findFontSize(maxChars);

          return {
            basedFontSize: basedFontSize,
            maxChars: maxChars
          };
        }
      }
    });
  };
})();



// WEBPACK FOOTER //
// ./ui/share/components/charting/highcharts/Izenda.SimpleGauge.js